import request from "./request";
/**
 * 获取商业信息
 */
export default async function getBusiness() {
  return await request.get("/spin/dataBusiness/getBusiness");
}
